export enum QuestionType {
  impactProbability = 'IMPACT_PROBABILITY',
  yesNo = 'YES_NO'
}
